import React from "react"

const Footer = () => {
  return (
    <footer>
      <div className="container">
        Imetengenezwa kwa ❤ na&nbsp;
        <a
          href="http://www.twitter.com/bmsteven_"
          target="_blank"
          rel="noopener noreferrer"
        >
          Benedict Steven
        </a>
      </div>
    </footer>
  )
}

export default Footer
